import { Link } from "react-router-dom";

function AboutPage() {
  return (
    <div className="min-h-screen bg-yellow-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-200 via-lime-100 to-yellow-100 py-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="mb-8">
            <img
              src="https://static.lumi.new/material/a9/a98ddac5f5da58315caa1c51a6d4a5ac.jpg"
              alt="Tiny Tots Sandbox"
              className="w-64 h-64 mx-auto rounded-full shadow-2xl border-8 border-white object-cover" />

          </div>
          <h1 className="text-5xl md:text-7xl font-black mb-6" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            <span className="text-sky-500">About</span>{" "}
            <span className="text-lime-500">the</span>{" "}
            <span className="text-yellow-500">Sandbox</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 font-semibold max-w-3xl mx-auto">
            Where every child's imagination builds castles of learning! 🏖️📚
          </p>
        </div>
      </section>

      {/* Section 1: Our Mission - Left Image / Right Text */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img
                src="https://static.lumi.new/material/84/84acacda25cfddaca26e3d07abc27eed.jpg"
                alt="STEAM Team"
                className="w-full rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-300" />

            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl md:text-5xl font-black mb-6 text-sky-600" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Our Mission: Play with Purpose 🎨
              </h2>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                At Tiny Tots Sandbox, we believe that every child's imagination is a world waiting to be explored. Our channel and website were created to be a safe, vibrant digital playground where learning feels like a game and curiosity never ends.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                Whether it's joining the STEAM Team to discover the wonders of science, meeting the Healthy Heroes to learn about nutritious choices, or diving into ABC Discovery with Mr. Fuzz, our goal is to spark 'Aha!' moments through high-quality animation and interactive storytelling.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Why the Sandbox - Right Image / Left Text */}
      <section className="py-20 bg-yellow-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="md:text-5xl font-black mb-6 text-lime-600 text-4xl" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>Why the 'Sandbox'? 🏖️

              </h2>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-4">
                A sandbox is where the best childhood memories are made—it's a place of endless possibilities, where you can build anything from a castle to a spaceship. We've taken that spirit and moved it into the digital world. Our content is designed to:
              </p>
              <div className="space-y-4 mb-4">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">🎯</span>
                  <div>
                    <p className="text-lg md:text-xl font-bold text-gray-800">Encourage Movement:</p>
                    <p className="text-lg md:text-xl text-gray-700">We don't just want kids watching; we want them 'Wiggling and Jumping!'</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-2xl">💪</span>
                  <div>
                    <p className="text-lg md:text-xl font-bold text-gray-800">Build Confidence:</p>
                    <p className="text-lg md:text-xl text-gray-700">Through motivational content, we help little explorers believe in themselves.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-2xl">👨‍👩‍👧</span>
                  <div>
                    <p className="text-lg md:text-xl font-bold text-gray-800">Support Parents:</p>
                    <p className="text-lg md:text-xl text-gray-700">We know the journey of parenthood is a big adventure, so we've curated the Parent's Corner to provide the essentials you need to keep the 'Sandbox' running smoothly at home.</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://static.lumi.new/material/41/41ac3eb0cd4bf93bfd70c50075dd9bb9.jpg"
                alt="Healthy Heroes"
                className="w-full rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-300" />

            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Meet the Team - Left Image / Right Text */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img
                src="https://static.lumi.new/material/a9/a98ddac5f5da58315caa1c51a6d4a5ac.jpg"
                alt="Logo"
                className="w-full rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-300" />

            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl md:text-5xl font-black mb-6 text-yellow-600" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                Meet the Team ✨
              </h2>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                Tiny Tots Sandbox is a family-run passion project. We are creators, parents, and big kids at heart who are dedicated to providing wholesome, clean, and engaging content that you can trust.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-sky-100 via-lime-100 to-yellow-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-black mb-8 text-gray-800" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            Ready for More Adventures? 🎬
          </h2>
          <Link to="/videos">
            <button className="group relative inline-block">
              <div className="relative bg-gradient-to-r from-sky-500 via-lime-500 to-yellow-400 text-white font-black text-2xl md:text-3xl px-16 py-6 rounded-full shadow-2xl transform transition-all duration-300 hover:scale-110 hover:rotate-2 active:scale-95" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                <span className="relative z-10 flex items-center gap-3">
                  🎥 Jump Back into the Videos!
                </span>
              </div>
              <div className="absolute inset-0 bg-gray-400 rounded-full transform translate-y-2 -z-10 group-hover:translate-y-3 transition-transform duration-300" />
            </button>
          </Link>
        </div>
      </section>
    </div>);

}

export default AboutPage;